import { Grid, TextField, FormControlLabel, Checkbox } from '@material-ui/core/';
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldError, useFormContext } from 'react-hook-form';
import { UserRole, getValidator } from '../../Constants/constants';
import { DictUserRole } from '../../API/Interfaces/IUserDtos';
import SelectLocation, { ISelectLocationProps } from '../../Layout/Components/SelectLocation';
import { isInRole } from '../../Utils/roleChecker';
import { UserContext } from '../../Context/UserContext';

interface IRuleFormProps {
	disabled?: boolean;
}

export default function RuleForm(props: IRuleFormProps) {
	const { t } = useTranslation();
	const { errors, register, setValue, getValues } = useFormContext();
	const userContext = useContext(UserContext);

	const formLabels = {
		title: t('repository.rules.ruleName'),
		description: t('repository.goals.description'),
		corporation: t('common.form.selectedCorporation'),
		isRequired: t('repository.rules.isRequired'),
	};

	const formValidators = {
		name: getValidator(t, 40, null, true),
		description: getValidator(t, 4000, null, true),
	};

	const selectLocationProps: ISelectLocationProps = {
		userFormType: DictUserRole.CorporationAdmin,
	};

	useEffect(() => {
		if (!(isInRole(userContext.userRoles, UserRole.DealerAdmin) || isInRole(userContext.userRoles, UserRole.SuperAdmin))) {
			setValue('corporationId', userContext.userWorkplaceId);
		}
	});

	return (
		<>
			<input name='id' ref={register()} hidden={true} />

			<Grid item xs={12}>
				<TextField
					error={errors.title !== undefined}
					helperText={(errors.title as FieldError)?.message}
					label={formLabels.title}
					name='title'
					inputRef={register(formValidators.name)}
					fullWidth
					disabled={props.disabled}
				/>
			</Grid>

			<Grid item xs={12}>
				<TextField
					error={errors.description !== undefined}
					helperText={(errors.description as FieldError)?.message}
					label={formLabels.description}
					name='description'
					inputRef={register(formValidators.description)}
					fullWidth
					multiline
					disabled={props.disabled}
				/>
			</Grid>

			<Grid item xs={12}>
				<FormControlLabel
					style={{ marginTop: '10px' }}
					control={
						<Checkbox
							color='secondary'
							defaultChecked={getValues().isRequired}
							name='isRequired'
							onChange={(e) => {
								setValue('isRequired', e.target.checked);
							}}
							inputRef={register()}
							disabled={props.disabled}
						/>
					}
					label={formLabels.isRequired}
				/>
			</Grid>

			{isInRole(userContext.userRoles, UserRole.DealerAdmin) || isInRole(userContext.userRoles, UserRole.SuperAdmin) ? (
				<>
					<SelectLocation {...selectLocationProps} />
					<Grid item xs={6} />
				</>
			) : (
				<input hidden name='corporationId' ref={register()}></input>
			)}
		</>
	);
}
